import { useContext } from 'react';
import { I18NextContext } from '../hoc';

export const mockT = (label: any) => label;
export const useI18NextContext: any = () => useContext(I18NextContext) || mockT;
